import { cookies } from './cookies';
import { jump } from './jump';
import { user } from './user';
import {localStore} from './storage'
import {http} from './http'
import _ from 'lodash'
import queryString from 'query-string'
import CONSTANT from './constant'
import { enterStatus } from './enums'

// 需要保留的客服cookie
const customerCookie = [
  'imLoginName',
  'kcspSiteToken',
  'kcspSiteUserId',
  'sourceType',
  'buzzId',
  '_platform_num'
]

class Util {
  setCookies(name, value, iHours, domain = '.haiziwang.com') {
    const oDate = new Date();
    oDate.setHours(oDate.getHours() + iHours);
    document.cookie = name + '=' + value + ';expires=' + oDate + ';domain=' + domain + ';path=/';
  }

  imagePreview(value, width, height, type, viewType) {
    const view = viewType || '2'
    let imgUrl = `${value}?imageView2/${view}`
    if (width) {
        imgUrl = `${imgUrl}/w/${width}`
    }
    if (height) {
        imgUrl = `${imgUrl}/h/${height}`
    }
    if (type) {
        imgUrl = `${imgUrl}/q/85/format/${type}`
    } else {
        imgUrl = `${imgUrl}/q/85/format/jpg`
    }
    return imgUrl
  }
  viewImage(value, width, height, type) {
    let img = ''
    if (value) {
        value = value.replace(/^http(s?):/, '')
        // if (isSupportWebp) {
        //     img = imagePreview(value, width, height, 'webp')
        // } else {
        img = this.imagePreview(value, width, height, type)
        // }
    }
    return img
  }
  /**
   * 确认登录
   */
  ensureLogin(name=''){
      if(!user.id) {
          jump.login(name);
          return false;
      } else {
          return true
      }
  }
  /**
   * 是否已登录
   */
  isLogin(){
    const id = user.id
    if(id){
        return true
    } else {
        return false
    }
  }

  /**
   * 获取元素的offsetTop
   * @param {*} 元素 
   * @param {*} 容器 
   */
  getOffsetTop(element, container = window) {
      if (!element) {
        return 0;
      }
    
      if (!element.getClientRects().length) {
        return 0;
      }
    
      const rect = element.getBoundingClientRect();
    
      if (rect.width || rect.height) {
        if (container === window) {
          container = element.ownerDocument.documentElement;
          return rect.top - container.clientTop;
        }
        return rect.top - container.getBoundingClientRect().top;
      }
    
      return rect.top;
    }
  /**
   * 清楚所有cookie
   */
  clearCookies(){
    Object.keys(cookies.get()).forEach(function(cookieName) {
      if(!customerCookie.includes(cookieName)) {
        cookies.remove(cookieName);
      }
    });
  }
  /**
   * 动态添加js
   * @param {*} url 
   * @param {*} callback 
   */
  loadJs(url,callback){
    var script=document.createElement('script');
      script.type="text/javascript";
      if(typeof(callback)!="undefined"){
        if(script.readyState){
          script.onreadystatechange=function(){
            if(script.readyState == "loaded" || script.readyState == "complete"){
              script.onreadystatechange=null;
              callback();
            }
          }
        }else{
          script.onload=function(){
            callback();
          }
        }
      }
      script.src=url;
      document.body.appendChild(script);
  }
  
  /**
   * 设置跳转其他平台连接
   */
  async getPartnerLink(){
    let linkSeller = ""
    let linkPartner = ""
    let seller = {}
    let partner = {}
    let yuer = {}
    let czj = {}
    if(localStore.getItem('jumpLinks')){
        const data = localStore.getItem('jumpLinks');
        seller = data.seller || {}
        partner = data.partner || {}
        yuer = data.yuer || {}
        czj = data.czj || {}
        linkSeller = seller.domain;
        linkPartner = partner.domain;
    } else {
        const response = await http.get('//cms.haiziwang.com/publish/976/pop-footer.json');
        if(response && response.data) {
            const res = response.data;
            if(res.jumpLinks) {
              const data = res.jumpLinks;
              seller = data.seller || {}
              partner = data.partner || {}
              yuer = data.yuer || {}
              czj = data.czj || {}
              linkSeller = seller.domain;
              linkPartner = partner.domain;
            }
        }
    }
    return {sellerLink:linkSeller || "//seller.haiziwang.com",partnerLink:linkPartner || "//partner.haiziwang.com", seller, partner, yuer, czj}
  }
  
  // 埋点上报
  $tracker(bizType, pageLevelId, logType=10000, clickId='', params={}){
    const popid = cookies.get('siteLoginName') || ''
    const btype = cookies.get('buzzType') || ''
    const tenantnum = cookies.get('_platform_num') || ''
    const reportParams = _.omitBy({popid, btype, tenantnum, link: window.location.pathname, ...params}, _.isNil)
    try{
      if(logType === 10000){
        window.track && window.track._launch(
          {
            bizType,
            pageLevelId,
            logType,
            clickId,
            pageParam: JSON.stringify(reportParams)
          }
        )
      }else{
        window.track && window.track._launch(
          {
            bizType,
            pageLevelId,
            logType,
            clickId,
            positionParam: JSON.stringify(reportParams)
          }
        )
      }
    }catch(e){
      console.log(e)
    }
  }

  // 是否是非商账号登录或非商来源
  isNc(userInfo) {
    let { source } = queryString.parse(location.search)
    if(userInfo) {
      // 登录状态下，以登录态判断
      // 商家类型8 表示非商供应商， 入驻类型10 表示入驻非商
      // 如果buzzType和settleInType都是null 表示刚注册的账户，还没有做入驻操作
      // 此时按照source来源判断
      if (userInfo.enterStatus === enterStatus.UNCOMMITTED || userInfo.enterStatus === enterStatus.REFUSE_TRANSITORY) {
        return source === 'ncsupplier-portal'
      } else if (!(_.isNil(userInfo.buzzType) && _.isNil(userInfo.settleInType))) {
        return userInfo.buzzType === 8 || userInfo.settleInType === 10
      }
    } else {
      // 非登录状态下以url上的source参数判断
      return source === 'ncsupplier-portal'
    }
  }
  jumptoNcHomepage() {
    top.location.href = CONSTANT.NC_PORTAL
  } 
  jumptoNcPlatform() {
    top.location.href = CONSTANT.NC_PLATFORM
  }
  jumptoNcEnter() {
    top.location.href = CONSTANT.NC_ENTER
  }
  sleep(s) {
    return new Promise((resolve) => setTimeout(resolve, s * 1000))
  }
}

export const util = new Util()
